module.exports = __webpack_public_path__ + "static/media/premisys_logo.d10301b1.svg";